/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Edit_Permissions_Legacy_HintInputs */

const vi_api_keys_edit_permissions_legacy_hint = /** @type {(inputs: Api_Keys_Edit_Permissions_Legacy_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoá này tạo trước khi có phân quyền nên đang có toàn quyền. Bỏ chọn quyền nào thì khoá mất quyền đó ngay khi lưu.`)
};

/**

* @param {Api_Keys_Edit_Permissions_Legacy_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_edit_permissions_legacy_hint = /** @type {((inputs?: Api_Keys_Edit_Permissions_Legacy_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Edit_Permissions_Legacy_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_edit_permissions_legacy_hint(inputs)
});